import React from 'react';
import { Link } from 'react-router-dom';
import { KeyboardArrowLeftOutlined } from '@mui/icons-material';

import ResetPasswordComponent from 'features/logon/resetPasswordComponent';
import navigationPaths from 'engine/navigationPaths';
import { OEM } from 'utility/OEMProvider';
import { resources } from 'oems/resources';

import * as Styled from './ForgotPassword.styles';

export const ForgotPassword = () => {
  return (
    <Styled.Wrapper>
      <img src={resources.logoDarkImage} alt="logo" className="logo" />
      <Styled.FormWrapper>
        <div className="content">
          <Styled.Title>Nie pamiętasz hasła?</Styled.Title>

          <p>Nie martw się, podaj swój adres email - wyślemy instrukcje jak ustawić nowe hasło.</p>

          <ResetPasswordComponent />

          <p className="backToLogin">
            <Link to={navigationPaths().LogIn}>
              <KeyboardArrowLeftOutlined /> Powrót do logowania
            </Link>
          </p>
        </div>

        <Styled.Copyright>{OEM().Copyright}</Styled.Copyright>
      </Styled.FormWrapper>

      <Styled.Description>
        <Styled.Title>Faktury automatyczne</Styled.Title>
        <p>Dzięki automatycznym fakturom, nie będziesz musiał pamiętać o wystawieniu dokumentów w każdym miesiącu.</p>
        <img src={resources.loginImage} alt="" />
      </Styled.Description>
    </Styled.Wrapper>
  );
};
